<template>
    <div class="hero-container">
      <!-- Cabecera -->
      <div class="top-bar">
        <div class="textos">
          <div class="header">
            <h1 class="titulo">Trabaja con millones de colores</h1>
            <img src="@/assets/logo.png" alt="HP y RM" class="logo-central" />
          </div>
          <div class="linea-subtitulo">
            <hr />
            <p>Espera más de una impresora</p>
            <hr />
          </div>
        </div>
      </div>
  
      <!-- Formulario -->
      <div class="form-container">
      <form @submit.prevent="enviarFormulario">
        <div class="form-grid">
          <div class="form-col">
            <div class="form-group actividad">
              <label>Actividad:</label>
              <label><input type="radio" value="penales" v-model="actividad" /> Penales</label>
              <label><input type="radio" value="dominadas" v-model="actividad" /> Dominadas</label>
            </div>

            <input type="text" v-model="nombre" placeholder="Nombre completo" />
            <input type="text" v-model="telefono" placeholder="Teléfono de contacto" />
            <input type="email" v-model="correo" placeholder="Correo electrónico" />
            <input type="text" v-model="record" placeholder="Récord" />

            <div class="form-group terminos">
              <label><input type="checkbox" v-model="aceptaTerminos" /> Acepto términos y condiciones de la dinámica</label>
              <p class="info-link">Para mayor información: https://terminosycondiciones.hpinfo.online</p>
            </div>
          </div>

          <div class="form-col auth-box">
            <label>Clave de autorización</label>
            <input type="password" v-model="clave" />
            <button type="submit">Enviar</button>
          </div>
        </div>
      </form>
    </div>

    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    data() {
        return {
            actividad: {
            penales: false,
            dominadas: false,
            },
            nombre: '',
            telefono: '',
            correo: '',
            record: '',
            clave: '',
            aceptaTerminos: false,
        };
        },

        methods: {
            async enviarFormulario() {
                if (this.clave !== 'HP0525') {
                    alert('Clave de autorización inválida');
                    return;
                }
                if (!this.aceptaTerminos) {
                    alert('Debes aceptar los términos y condiciones');
                    return;
                }

                try {
                    await axios.post('/api/registro-encuesta', {
                    actividad: this.actividad,
                    nombre: this.nombre,
                    telefono: this.telefono,
                    correo: this.correo,
                    record: this.record,
                    });
                    alert('Gracias por participar');
                    this.actividad = '';
                    this.nombre = '';
                    this.telefono = '';
                    this.correo = '';
                    this.record = '';
                    this.clave = '';
                    this.aceptaTerminos = false;
                } catch (error) {
                    alert('Error al enviar el formulario');
                }
            },
        },

  };
  </script>
  
<style lang="scss"  scoped>
.hero-container {
  background-color: #0095d9;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'FormaDJRDisplay', sans-serif;
  overflow: hidden;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 2rem 0 1rem 0;
  color: white;
}

.textos {
  flex: 1;
  .header {
    display: flex;
    padding: 0 2rem 0 2rem;
    justify-content: space-between;
  }
  .titulo {
    font-size: 6rem;
    // font-weight: bold;
    max-width: 800px;
    letter-spacing: 3px;
    text-align: left;
    margin: 0;
    line-height: 1;
  }

  .linea-subtitulo {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 0.5rem;
    gap: 1rem;
    text-align: left;
    
    hr {
      flex: 1;
      border: none;
      min-height: 1px;
      min-width: 100%;
      background-color: white;
    }

    p {
      margin: 0;
      font-size: 2rem;
      white-space: nowrap;
      letter-spacing: 1px;
      width: 100%;
      line-height: 0.5;
      padding: 0 2rem;
    }
  }
}

.logo-central {
  height: 180px;
  margin-left: 2rem;
}

.main-images {
  display: flex;
  flex: 1;
  img {
    width: 50%;
    height: auto;
    object-fit: cover;
  }
}

.bottom-bar {
  text-align: center;
  // padding: 0.5rem 2rem 1.5rem 2rem;
}

.start-linea {
  display: flex;
  align-items: center;
  // gap: 1rem;

  hr {
    flex: 1;
    border: none;
    height: 1px;
    background-color: white;
  }

  .start-button {
    background-color: transparent;
    color: white;
    font-size: 1.1rem;
    border: none;
    display: block;
    width: 100%;
    padding: 1rem 2rem;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    letter-spacing: 1px;
    &:hover {
      background-color: white;
      color: #0095d9;
    }
  }
}
.form-container {
  padding: 2rem;
  font-family: 'FormaDJRDisplay', sans-serif;
  color: white;
    width: 1200px;
    margin: 0 auto;
  form {
    width: 100%;
  }

  .form-grid {
    display: flex;
    gap: 2rem;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .form-col {
    flex: 1;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .form-group.actividad {
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: 1.2rem;

    label:first-child {
      font-weight: bold;
    }

    input[type='checkbox'] {
      margin-right: 0.5rem;
    }
  }

  input[type="password"],
  input[type="text"],
  input[type="email"] {
    padding: 0.5rem 1rem;
    font-size: 1rem;
    border: none;
    width: 100%;
    background: white;
    color: black;
  }

  .form-group.terminos {
    font-size: 1rem;

    .info-link {
      font-size: 0.9rem;
      margin-top: 0.25rem;
    }

    input[type='checkbox'] {
      margin-right: 0.5rem;
    }
  }

  .auth-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    input[type="password"] {
      width: 200px;
    }

    button {
      margin-top: 0.5rem;
      background: transparent;
      border: 1px solid white;
      color: white;
      font-size: 1.2rem;
      padding: 0.5rem 2rem;
      cursor: pointer;

      &:hover {
        background: white;
        color: #0095d9;
      }
    }

    label {
      font-size: 1.1rem;
      margin-bottom: -0.5rem;
    }
  }
}

  </style>
  